// Ambil hanya userId dari JWT accessToken
export const getUserIdFromToken = () => {
  const token = localStorage.getItem('accessToken');
  if (!token) return null;

  try {
    const payloadBase64 = token.split('.')[1];
    const payload = JSON.parse(atob(payloadBase64));
    return payload.user?.id || null;
  } catch (error) {
    console.error('Failed to decode token:', error);
    return null;
  }
};
